import React from "react";
import "./UserNavlinks.css";

const UserNavlinks = ({ NavLink, userLinks, handleLogout, toggleSidebar }) => {
  console.log("toggleSidebar", toggleSidebar);

  return (
    <div className="nav-links">
      {userLinks.map((link) => {
        const { text, path, id, icon } = link;

        return (
          <NavLink
            to={path}
            key={id}
            className={({ isActive }) =>
              isActive ? "active nav-link" : "nav-link"
            }
            onClick={toggleSidebar}
          >
            <span style={{ marginLeft: "-20px", paddingRight: "15px" }}>
              {icon}
            </span>
            {text}
          </NavLink>
        );
      })}
      <button
        style={{ background: "none", border: "none", cursor: "pointer" }}
        className="nav-link"
        onClick={handleLogout}
      >
        Logout
      </button>
    </div>
  );
};
export default UserNavlinks;
